import * as React from 'react';
export const appsSvg = React.forwardRef(function appsSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M9.25 0a.75.75 0 0 1 .75.75V2h1.25a.75.75 0 0 1 0 1.5H10V5a.75.75 0 0 1-1.5 0V3.5H7A.75.75 0 0 1 7 2h1.5V.75A.75.75 0 0 1 9.25 0Zm-5.5 1.55H1.5a.2.2 0 0 0-.2.2V4c0 .11.09.2.2.2h2.25a.2.2 0 0 0 .2-.2V1.75a.2.2 0 0 0-.2-.2ZM1.5.25A1.5 1.5 0 0 0 0 1.75V4a1.5 1.5 0 0 0 1.5 1.5h2.25A1.5 1.5 0 0 0 5.25 4V1.75a1.5 1.5 0 0 0-1.5-1.5H1.5Zm2.25 7.8H1.5a.2.2 0 0 0-.2.2v2.25c0 .11.09.2.2.2h2.25a.2.2 0 0 0 .2-.2V8.25a.2.2 0 0 0-.2-.2ZM1.5 6.75A1.5 1.5 0 0 0 0 8.25v2.25A1.5 1.5 0 0 0 1.5 12h2.25a1.5 1.5 0 0 0 1.5-1.5V8.25a1.5 1.5 0 0 0-1.5-1.5H1.5ZM8 8.05h2.25c.11 0 .2.09.2.2v2.25a.2.2 0 0 1-.2.2H8a.2.2 0 0 1-.2-.2V8.25c0-.11.09-.2.2-.2Zm-1.5.2A1.5 1.5 0 0 1 8 6.75h2.25a1.5 1.5 0 0 1 1.5 1.5v2.25a1.5 1.5 0 0 1-1.5 1.5H8a1.5 1.5 0 0 1-1.5-1.5V8.25Z',
      clipRule: 'evenodd',
    }),
  );
});
appsSvg.defaultProps = {
  width: '12',
  height: '12',
  viewBox: '0 0 12 12',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var apps = {
  category: 'icon',
  colorable: true,
  name: 'apps',
  svg: appsSvg,
};
